import useDocumentMeta from '@/hooks/useDocumentMeta';
import HeroSection from './components/HeroSection';
import EventEntries from './components/EventEntries';
import BlacklistHighlight from './components/BlacklistHighlight';
import NewsSection from './components/NewsSection';
import TopicsGrid from './components/TopicsGrid';
import SiteIntro from './components/SiteIntro';

export default function Home() {
  useDocumentMeta({
    title: '51每日大赛今日黑榜 - 实时更新时间及赛事资讯',
    description:
      '51每日大赛为您提供最新的每日大赛今日黑榜信息和实时更新时间，涵盖赛事排名、选手表现等全方位资讯，助您及时了解比赛动态。',
    keywords: '51每日大赛,每日大赛,今日黑榜,黑榜更新时间,赛事资讯,比赛排名,选手表现',
  });

  return (
    <>
      <HeroSection />
      <EventEntries />
      <BlacklistHighlight />
      <NewsSection />
      <TopicsGrid />
      <SiteIntro />
    </>
  );
}